import { render, staticRenderFns } from "./AccountStep.vue?vue&type=template&id=5a4cca67&scoped=true&lang=pug"
import script from "./AccountStep.vue?vue&type=script&lang=js"
export * from "./AccountStep.vue?vue&type=script&lang=js"
import style0 from "./AccountStep.vue?vue&type=style&index=0&id=5a4cca67&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4cca67",
  null
  
)

export default component.exports